import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import dayjs from 'dayjs';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';

import { challenge1, challenge2, challenge3, challenge4, challenge5, challenge6, challenge7, challenge8, challenge9, challenge10 } from '../../../../core/data/challenges';
import styles from './styles.module.scss';

export class OldChallenges extends Component {
  constructor(props) {
    super(props);
    const { match, location } = this.props;
    this.campaignId = match.params?.id;
    this.canAccess = location.state?.canAccess;

    this.state = {
      videos: [],
      challenge: null,
    };
  }

  currentDateIsAfterDateTo = dateTo => {
    return dayjs().isAfter(dateTo, 'days');
  };

  getCampaign = async () => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Campaign.getByIdWithoutDetail,
      null,
      'GET',
      { Authorization: this.props.token },
      {
        campaignId: this.campaignId,
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let c;
          if (result.title.includes("1º")) {
            c = challenge1;
          }
          if (result.title.includes("2º")) {
            c = challenge2;
          }
          if (result.title.includes("3º") ) {
            c = challenge3;
          }
          if (result.title.includes("4º") ) {
            c = challenge4;
          }
          if (result.title.includes("5º") ) {
            c = challenge5;
          }
          if (result.title.includes("6º") ) {
            c = challenge6;
          }
          if (result.title.includes("7º") ) {
            c = challenge7;
          }
          if (result.title.includes("8º") ) {
            c = challenge8;
          }
          if (result.title.includes("9º") ) {
            c = challenge9;
          }
          if (result.title.includes("10º") ) {
            c = challenge10;
          }
          this.setState({
            challenge: result,
            videos: c.test,
            campaign: c
          });
        } else {
          this.props.publishErrorAlert('Houve um erro ao carregar os desafio');
        }
        this.props.loaderHide();
      }
    );
  };

  componentDidMount() {
    const { history } = this.props;

    if (!this.canAccess) {
      history.push('/glampartner/glamstar/desafios');
      return;
    }

    this.getCampaign();
  }

  render() {
    const { videos, challenge, campaign } = this.state;

    if (!challenge) {
      return null;
    }

    const challengeClosed = this.currentDateIsAfterDateTo(challenge.dateTo);

    let currentChallenge = {
      ...challenge,
      dateFrom: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateFrom)),
      dateTo: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateTo)),
    };

    return (
      <div className={styles.container}>
        <header className={styles.concurseHeader}>
          <h1 className={styles.concurseTitle}>{currentChallenge.title}</h1>
          <span className={styles.concurseTime}>
            Prazo: <time>{currentChallenge.dateFrom}</time> até{' '}
            <time>{currentChallenge.dateTo}</time>
          </span>
        </header>

        <main className={styles.hero}>
          <div className={styles.challengeWrapper}>
            <video className={styles.currentChallengeVideo} controls>
              <source
                src={campaign.videoChallenge}
                type="video/mp4"
              />
            </video>
          </div>

          {
            (() => {
              if(!campaign.name.includes("7º")){ 
                return (
                <section className={styles.rules}>
                  <h2 className={styles.rulesTitle}>Missão</h2>
                  <div className={styles.rulesContent}>
                  <ul className={styles.rulesListDisc}>
                    {
                      (() => {
                        return campaign.mission.map((value, key) => {
                          return (
                            <p className={styles.paragraph} value={value} key={key}>
                              {value}
                            </p>
                          );
                        });
                      })()
                    }
                    {
                      (() => {
                        if(campaign.name.includes("7º")) {
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionTip}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (() => {
                       if(campaign.missionRulesTitle) {
                        return campaign.missionRulesTitle.map((value, key) => {
                          return (
                            <p className={styles.paragraph} value={value} key={key}>
                              {value}
                            </p>
                          );
                        });
                       }
                      })()
                    }
                    {
                      (() => {
                      if (campaign.missionRules.length > 1) {
                        return campaign.missionRules.map((value, key) => {
                          return (
                            <li value={value} key={key}>
                              {value}
                            </li>
                          );
                        });
                      }
                      })()
                    }
                    <br />
                    </ul>
                    {
                      (() => {
                        if(!campaign.name.includes("7º")) {
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionTip}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (() => {
                        if (campaign.name.includes("7º") && campaign.missionRules.length > 1) {
                          return campaign.missionFooter.map((value, key) => {
                            return (
                              <p className={styles.paragraph} value={value} key={key}>
                                {value}
                              </p>
                            );
                          });
                        }
                      })()
                    }
                    {
                      (() => {
                        if(campaign.name.includes("7º") && campaign.missionFooter.length > 0){
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionFooter[0]}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (()=> {
                        if(campaign.name.includes("7º") && campaign.missionFooter.length > 0){
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionFooter[1]} <a href="{campaign.missionFooter}">{campaign.missionFooterLinks}</a>
                            </p>
                          )
                        }
                      })()
                    }
                    </div>
                </section>
                )
              }
            })()
          }

          {
            (() => {
              if(campaign.name.includes("7º")){
                return (
                <section className={styles.rules}>
                  <h2 className={styles.rulesTitle}>Missão</h2>
                  <div className={styles.rulesContent}>
                  <ol className={styles.rulesList}>
                    {
                      (() => {
                        return campaign.mission.map((value, key) => {
                          return (
                            <p className={styles.paragraph} value={value} key={key}>
                              {value}
                            </p>
                          );
                        });
                      })()
                    }
                    {
                      (() => {
                        if(campaign.name.includes("7º")) {
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionTip}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (() => {
                        return campaign.missionRulesTitle.map((value, key) => {
                          return (
                            <p className={styles.paragraph} value={value} key={key}>
                              {value}
                            </p>
                          );
                        });
                      })()
                    }
                    {
                      (() => {
                      if (campaign.missionRules.length > 1) {
                        return campaign.missionRules.map((value, key) => {
                          return (
                            <li value={value} key={key}>
                              {value}
                            </li>
                          );
                        });
                      }
                      })()
                    }
                    <br />
                    </ol>
                    {
                      (() => {
                        if(!campaign.name.includes("7º")) {
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionTip}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (() => {
                        if (campaign.missionRules.length > 1) {
                          return campaign.missionFooter.map((value, key) => {
                            return (
                              <p className={styles.paragraph} value={value} key={key}>
                                {value}
                              </p>
                            );
                          });
                        }
                      })()
                    }
                    {
                      (() => {
                        if(campaign.name.includes("7º") && campaign.missionFooter.length > 0){
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionFooter[0]}
                            </p>
                          )
                        }
                      })()
                    }
                    {
                      (()=> {
                        if(campaign.name.includes("7º") && campaign.missionFooter.length > 0){
                          return (
                            <p className={styles.paragraph}>
                              {campaign.missionFooter[1]} <a href="{campaign.missionFooter}">{campaign.missionFooterLinks}</a>
                            </p>
                          )
                        }
                      })()
                    }
                    </div>
                </section>
                )
              }
            })()
          }

          {
            (() => {
              if(campaign.name.includes("7º") && campaign.benefitsTitle.length > 0){
                return (
                  <section className={styles.rules}>
                    <h2 className={styles.rulesTitle}>{campaign.benefitsTitle}</h2>
                    <div className={styles.rulesContent}>
                      <ul className={styles.rulesListDisc}>
                      {
                        (() => {
                          return campaign.benefitsList.map((value, key) => {
                            return (
                              <li value={value} key={key}>
                                {value}
                              </li>
                            );
                          });
                        })()
                      }
                      </ul>
                      <p className={styles.paragraph}>
                        <strong>Desenhamos todas essas divulgações para te ajudar a ganhar ainda mais destaque nas suas redes sociais e ainda mais seguidoras, te ajudando a virar uma influencer de sucesso!</strong>
                      </p>
                    </div>
                  </section>
                )
              }
            })()
          }
        <br />

          <section className={styles.rules}>
            <h2 className={styles.rulesTitle}>Regras</h2>
            <div className={styles.rulesContent}>
              <ol className={styles.rulesList}>
                {
                  (() => {
                    return campaign.rules.map((value, key) => {
                      return (
                        <li value={value} key={key}>
                          {value}
                        </li>
                      );
                    });
                  })()
                }
              </ol>
              <p className={styles.rulesDescription}>
                {campaign.rulesDescription}
              </p>

              <strong className={styles.rulesInfo}>Tempo e formato</strong>

              {
                  (() => {
                    return campaign.format.map((value, key) => {
                      return (
                        <p value={value} key={key} className={styles.rulesDescription}>
                          {value}
                        </p>
                      );
                    });
                  })()
                }
                {
                  (() => {
                    if(campaign.formatList) {
                      return campaign.formatList.map((value, key) => {
                        return (
                          <ul className={styles.rulesListDisc}>
                            <li value={value} key={key}>
                              {value}
                            </li>
                          </ul>
                          
                        );
                      });
                    }
                  })()
                }
              <strong className={styles.rulesInfo}>Prazo de envio</strong>
                <p className={styles.rulesDescription}>
                  {campaign.submissionDeadline1}
                </p>
                <p className={styles.rulesDescription}>  
                  {campaign.name.includes("7") ? "" : campaign.submissionDeadline2} 
                </p>
              <ol className={styles.rulesListDisc}>
                <strong className={styles.rulesInfo}>
                  Critérios de avaliação
                </strong>
                {
                  (() => {
                    return campaign.avaliationCriteria.map((value, key) => {
                      return (
                        <li value={value} key={key}>
                          {value}
                        </li>
                      );
                    });
                  })()
                }
              </ol>
            </div>
          </section>

          <section className={styles.challengesExample}>
            <h2 className={styles.challengeExampleTitle}>{videos?.length > 0 ? 'Vídeos de exemplo' : ''}</h2>
            <p className={styles.paragraph}>
              {
                videos?.length > 0 ?
                'Nosso time preparou alguns exemplos de vídeos para te ajudar a se soltar! Capriche muito na sua produção.'
                  : ''
              }
            </p>
            <div className={styles.videosExample}>
              {
                videos?.length > 0 &&
                videos.map(video => (
                  <video key={video.title} controls>
                    <source src={video.url} type="video/mp4"></source>
                  </video>
                ))
              }
            </div>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

OldChallenges = connect(
  mapStateToProps,
  mapDispatchToProps
)(OldChallenges);
